<template>
    <div class="card-columns">
      <router-link
        :to="'/detail/'+item.id"
        class="card artikel"
        tag="div"
        v-for="(item) in elements"
        :key="'artikel_' + item.id"
      >
        <progressive-img
          :src="item.img"
          alt
          class="card-img-top listimage"
          :placeholder="item.img_thumb"
          :aspect-ratio="item.ratio"
        />
        <div class="card-body">
          <h5 class="card-title">
            {{item.naam}}
            <small class="float-right">€ {{item.prijs_donated}} / € {{item.prijs}}</small>
          </h5>
          <p class="card-text">{{item.description}}</p>
        </div>
      </router-link>
    </div>
</template>
<script>
export default {
    props:["elements"]
}
</script>
